// src/pages/Parametros/tabs/TabDuplicata.jsx
import React from 'react';
import {
    Box, TextField, Typography, Paper,
    FormControl, InputLabel, Select, MenuItem,
    Divider, Chip,
} from '@mui/material';
import { useParametrosAnalise } from '../../../context/ParametrosAnaliseContext';

function buildFaixas(d) {
    return [
        { label: 'Muito boa', color: 'success', range: `≤ ${d.limiteMuitoBoa}x` },
        { label: 'Aceitável', color: 'info', range: `${d.limiteMuitoBoa}x – ${d.limiteAceitavel}x` },
        { label: 'Atenção', color: 'warning', range: `${d.limiteAceitavel}x – ${d.limiteAtencao}x` },
        { label: 'Inconsistência', color: 'error', range: `> ${d.limiteAtencao}x` },
    ];
}

export default function TabDuplicata() {
    const { params, updateGroup } = useParametrosAnalise();
    const d = params.duplicata;
    const set = (field, value) => updateGroup('duplicata', { [field]: value });

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 3 }}>
            <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle1" fontWeight={600} mb={2}>
                    Limites de consistência entre duplicatas
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <TextField
                        label='Limite "Muito boa" (até Nx)'
                        type="number"
                        value={d.limiteMuitoBoa}
                        onChange={(e) => set('limiteMuitoBoa', Number(e.target.value))}
                        inputProps={{ min: 1 }}
                        sx={{ width: 220 }}
                        helperText="Ex: 2 → até 2x = muito boa"
                    />
                    <TextField
                        label='Limite "Aceitável" (até Nx)'
                        type="number"
                        value={d.limiteAceitavel}
                        onChange={(e) => set('limiteAceitavel', Number(e.target.value))}
                        inputProps={{ min: 1 }}
                        sx={{ width: 220 }}
                        helperText="Ex: 5 → até 5x = aceitável"
                    />
                    <TextField
                        label='Limite "Atenção/Inconsistência" (até Nx)'
                        type="number"
                        value={d.limiteAtencao}
                        onChange={(e) => set('limiteAtencao', Number(e.target.value))}
                        inputProps={{ min: 1 }}
                        sx={{ width: 280 }}
                        helperText="Acima disto = inconsistência"
                    />
                </Box>
            </Paper>

            <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle1" fontWeight={600} mb={2}>
                    Preview das faixas (calculado automaticamente)
                </Typography>
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 3 }}>
                    {buildFaixas(d).map((f) => (
                        <Chip
                            key={f.label}
                            label={`${f.label}: ${f.range}`}
                            color={f.color}
                            variant="outlined"
                            sx={{ fontWeight: 600 }}
                        />
                    ))}
                </Box>
                <Divider sx={{ mb: 2 }} />
                <FormControl sx={{ width: 320 }}>
                    <InputLabel>Ação em inconsistência</InputLabel>
                    <Select
                        value={d.acaoEmInconsistencia}
                        label="Ação em inconsistência"
                        onChange={(e) => set('acaoEmInconsistencia', e.target.value)}
                    >
                        <MenuItem value="repetir_analise">Repetir análise</MenuItem>
                        <MenuItem value="nao_prosseguir">Não prosseguir com cálculo</MenuItem>
                    </Select>
                </FormControl>
            </Paper>
        </Box>
    );
}
